import apiClient from './apiClient';
import { storageService } from '../../domain/services/StorageService.js';

const formatPhoneNumber = (phoneNumber) => phoneNumber.replace(/\D/g, '');

export const sendOtp = (contactNumber) => apiClient.post('/users/send-otp', { contactNumber: formatPhoneNumber(contactNumber) }, { skipAuth: true });
export const verifyOtp = (contactNumber, otp) => apiClient.post('/auth/login-otp', { contactNumber: formatPhoneNumber(contactNumber), otp: otp.toString() }, { skipAuth: true });
export const loginWithPassword = (contactNumber, password) => apiClient.post('/auth/login', { contactNumber: formatPhoneNumber(contactNumber), password }, { skipAuth: true });
export const registerUser = (contactNumber, name, email) => apiClient.post('/users/register', { contactNumber: formatPhoneNumber(contactNumber), name, email }, { skipAuth: true });
export const sendForgotPasswordOtp = (contactNumber) => apiClient.post('/users/send-otp', { contactNumber: formatPhoneNumber(contactNumber) }, { skipAuth: true });
export const verifyForgotPasswordOtp = (contactNumber, otp) => apiClient.post('/users/verify-forgot-password-otp', { contactNumber: formatPhoneNumber(contactNumber), otp: parseInt(otp) }, { skipAuth: true });
export const setPassword = (password) => apiClient.patch('/users/set-password', { password });
export const setNewPassword = (contactNumber, password) => apiClient.patch('/users/set-password', { contactNumber: formatPhoneNumber(contactNumber), password });
export const updateProfile = (payload) => apiClient.patch('/users', payload);
export const logout = async () => {
  try {
    await apiClient.post('/auth/logout');
  } catch (error) {
    console.warn('Logout error:', error);
  } finally {
    storageService.clearAuth();
  }
};
export const getAuthMe = () => apiClient.get('/auth/me');
export const switchProfile = (businessId) => apiClient.post('/auth/switch-profile', { businessId });
export const getMyBusinessProfile = (accessToken) => apiClient.get('/businesses/my-profile', { skipAuth: true, headers: { 'Authorization': `Bearer ${accessToken}` } });
